// This is duplicated in Ruby: ClientMeeting::SUPPORTED_EXTERNAL_NOTE_FILE_EXTENSIONS
const SUPPORTED_TEXT_FILE_FORMATS = ['TXT', 'PDF']

const SUPPORTED_IMAGE_FILE_FORMATS = ['PNG', 'JPG', 'JPEG', 'WebP']

const SUPPORTED_AUDIO_FILE_FORMATS = [
  'AAC',
  'FLAC',
  'MP3',
  'MPA',
  'MPEG',
  'MPGA',
  'MP4',
  'OPUS',
  'PCM',
  'WAV',
  'WEBM',
]

export const allowedFilenameExtensions = [
  ...SUPPORTED_AUDIO_FILE_FORMATS,
  ...SUPPORTED_IMAGE_FILE_FORMATS,
  ...SUPPORTED_TEXT_FILE_FORMATS,
]
  .map((ext) => `.${ext}`.toLowerCase())
  .join(',')
